<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div class="lightbox">
      <div>
        <h1>Booth style</h1>
        <p class="my-3">&nbsp;</p>
        <div class="alert bg-light">
          <p>
            Choose one booth type, and click
            <u style="color: rgb(207, 71, 71)">SAVE</u>
            for your latest update.
          </p>
        </div>
        <div class="container">
          <form>
            <div class="cc-selector">
              <div v-if="!isVip">
                <div class="row my-4">
                  <div class="col-sm-6 text-center mt-2 mb-4">
                    <h5 class="mb-2">Standard A</h5>
                    <input
                      id="vendor_topic1"
                      type="radio"
                      name="credit-card"
                      v-model="Booth_Design"
                      value="A1"
                    />
                    <label
                      class="drinkcard-cc vendor_topic1 img-fluid"
                      for="vendor_topic1"
                    >
                    </label>
                  </div>
                  <div class="col-sm-6 text-center mt-2">
                    <h5 class="mb-2">Standard B</h5>
                    <input
                      id="vendor_topic2"
                      type="radio"
                      name="credit-card"
                      v-model="Booth_Design"
                      value="A2"
                    />
                    <label
                      class="drinkcard-cc vendor_topic2 img-fluid"
                      for="vendor_topic2"
                    ></label>
                  </div>

                  <div class="col-sm-6 text-center mt-2">
                    <h5 class="mb-2">Standard C</h5>
                    <input
                      id="vendor_topicA3"
                      type="radio"
                      name="credit-card"
                      v-model="Booth_Design"
                      value="A3"
                    />
                    <label
                      class="drinkcard-cc vendor_topicA3 img-fluid"
                      for="vendor_topicA3"
                    ></label>
                  </div>

                  <div class="col-sm-6 text-center mt-2">
                    <h5 class="mb-2">Standard D</h5>
                    <input
                      id="vendor_topicA4"
                      type="radio"
                      name="credit-card"
                      v-model="Booth_Design"
                      value="A4"
                    />
                    <label
                      class="drinkcard-cc vendor_topicA4 img-fluid"
                      for="vendor_topicA4"
                    ></label>
                  </div>

                  <div class="col-sm-6 text-center mt-2">
                    <h5 class="mb-2">Standard E</h5>
                    <input
                      id="vendor_topicA5"
                      type="radio"
                      name="credit-card"
                      v-model="Booth_Design"
                      value="A5"
                    />
                    <label
                      class="drinkcard-cc vendor_topicA5 img-fluid"
                      for="vendor_topicA5"
                    ></label>
                  </div>

                  <div class="col-sm-6 text-center mt-2">
                    <h5 class="mb-2">Standard F</h5>
                    <input
                      id="vendor_topicA6"
                      type="radio"
                      name="credit-card"
                      v-model="Booth_Design"
                      value="A6"
                    />
                    <label
                      class="drinkcard-cc vendor_topicA6 img-fluid"
                      for="vendor_topicA6"
                    ></label>
                  </div>
                </div>
              </div>
              <div v-if="isVip">
                <div class="row my-4">
                  <div class="col-sm-6 text-center mt-2 mb-4">
                    <h5 class="mb-2">Premium A</h5>

                    <input
                      id="vendor_topic3"
                      type="radio"
                      name="credit-card"
                      v-model="Booth_Design"
                      value="B1"
                    />
                    <label
                      class="drinkcard-cc vendor_topic3 img-fluid"
                      for="vendor_topic3"
                    >
                    </label>
                  </div>
                  <div class="col-sm-6 text-center mt-2 mb-4">
                    <h5 class="mb-2">Premium B</h5>

                    <input
                      id="vendor_topic4"
                      type="radio"
                      name="credit-card"
                      v-model="Booth_Design"
                      value="B2"
                    />
                    <label
                      class="drinkcard-cc vendor_topic4 img-fluid"
                      for="vendor_topic4"
                    ></label>
                  </div>
                  <div class="col-sm-6 text-center mt-2 mb-4">
                    <h5 class="mb-2">Premium C</h5>

                    <input
                      id="vendor_topic5"
                      type="radio"
                      name="credit-card"
                      v-model="Booth_Design"
                      value="B3"
                    />
                    <label
                      class="drinkcard-cc vendor_topic5 img-fluid"
                      for="vendor_topic5"
                    ></label>
                  </div>
                  <div class="col-sm-6 text-center mt-2">
                    <h5 class="mb-2">Premium D</h5>

                    <input
                      id="vendor_topic6"
                      type="radio"
                      name="credit-card"
                      v-model="Booth_Design"
                      value="B4"
                    />
                    <label
                      class="drinkcard-cc vendor_topic6 img-fluid"
                      for="vendor_topic6"
                    ></label>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer justify-content-center">
          <div class="PcDevice">
            <button
              type="button"
              class="btn btn-primary btn-lg"
              data-dismiss="modal"
              @click.prevent="EsaveBoothDesign"
            >
              Save
            </button>
          </div>
          <div class="MbDevice">
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click.prevent="EsaveBoothDesign"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  data() {
    return {
      CSRF_Token: "",
      RegNo: "",
      lang: "en",

      previews: {},
      previewStyle1: {},
      modelSrc: "./images/BannerA.jpg",
      modelSrc4: "./images/BannerC.jpg",
      modelSrc_0: "./images/default_sm.jpg",
      modelSrc_1: "./images/BannerB.jpg",
      modelSrc_2: "./images/default_sm.jpg",
      modelSrc_4: "./images/Exh_type2.jpg",
      NomodelSrc: "./images/default_sm.jpg",
      showImg: false,

      option: {
        img: "",
        max: 9999,
        enlarge: 1,
        mode: "contain",
        centerBox: false,
        canMove: true,
        infoTrue: true,
        fixedBox: true,
        canMoveBox: false,
        autoCrop: true,
        autoCropWidth: 500,
        autoCropHeight: 500,
        full: true,
        high: true,
        original: true,
        size: 1,
        outputType: "png",
      },

      fixed: true,
      fixedNumber1: [1, 2],
      fixedNumber4: [2, 1],

      logoImg: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",

      // 攤位內容
      Booth_Design: "",
      Serno: "",
      ExpovideoLink: "",
      videoLink_Youku: "",
      ExpoM_Banner1: "",
      ExpoM_Banner2: "",
      ExpoM_Banner3: "",
      ExpoM_Banner4: "",
      ExpoL_Banner1: "",
      ExpoL_Banner2: "",
      ExpoL_Banner3: "",
      ExpoL_Banner4: "",

      isVip: false,
      hasExpoVideo: false,
      hasExpoTopic: false,
      hasAllBanner: false,
      hasCard: false,
      firstEntry: true,

      CardInfo: [],
      ExhibitorWebsite: "",
      showOnlineExhLink: false,

      ExhInfo: {},
      r_Profile: "", //去<br>
      OnlineExhcode: "", //加密展code

      hasProduct: true,
      GetExhPro: {},

      exhVideo: [],
      hasVideo: true,

      hasNews: true,
      ExhNewsList: [],

      VerifiedCardInfo: [],
      CardInfo: [],

      Useremail: "",
      Username: "",
      CompanyTel: "",
      allPhone: "",

      //判斷各頁狀態儀表版值
      OnlineExpolayoutStatus: "",
      PressReleaseStatus: "",
      VideoStatus: "",
      ProductStatus: "",
      BasicinformationStatus: "",

      //判斷儀表板是否有線上展
      HasOnlineExpo: "",
      openOnlineExpo: "",
      showOnlineStatus: false,

      OnlineExpoProfile: {},
    };
  },
  methods: {
    openUserModal() {
      $("#UserDesk").modal("show");
    },

    openProductModal() {
      const vm = this;

      axios
        .get(
          `https://www.chanchao.com.tw/apiExhibitors/BoothPreviewProduct/${vm.RegNo}`,
        )
        .then((response) => {
          // console.log(response.data.Data)

          if (response.data.Data.length == 0) {
            vm.hasProduct = false;
          } else {
            vm.hasProduct = true;
          }
          vm.GetExhPro = response.data.Data;
        });

      $("#openProductModal").modal("show");
    },

    openVideoModal() {
      const vm = this;

      axios
        .get(
          `https://www.chanchao.com.tw/apiExhibitors/BoothPreviewVideo/${vm.RegNo}`,
        )
        .then((response) => {
          // console.log(response.data.Data)

          if (response.data.Data.length == 0) {
            vm.hasVideo = false;
          } else {
            vm.hasVideo = true;
          }
          vm.exhVideo = response.data.Data;
        });

      $("#openVideoModal").modal("show");
    },
    openNewsModal() {
      const vm = this;

      //取得參展商新聞稿資料

      axios
        .get(
          `https://www.chanchao.com.tw/apiExhibitors/BoothPreviewPressRelease/${vm.RegNo}`,
        )
        .then((response) => {
          // console.log(response.data.Data)

          if (response.data.Data.length == 0) {
            vm.hasNews = false;
          } else {
            vm.hasNews = true;
          }
          vm.ExhNewsList = response.data.Data;
        });
      $("#openNewsModal").modal("show");
    },

    openInquiryModal(Source) {
      const vm = this;

      //取得攤位人員資料
      axios
        .get(
          `https://www.chanchao.com.tw/apiExhibitors/BoothPreviewBoothstaff/${vm.RegNo}`,
        )
        .then((response) => {
          // console.log(response.data.Data)

          //取得攤販資料則取消瀏覽畫面

          vm.VerifiedCardInfo = response.data.Data.filter((item) => {
            return item.Verified == 1;
          });

          vm.CardInfo = vm.VerifiedCardInfo;

          if (vm.CardInfo.length > 0) {
            $("#openInquiryModal").modal("show");
          } else {
            if (Source == 2) {
              alert("您尚未進行電子名片設定，請先完成設定。");
            } else if (Source == 3) {
              alert(
                "You have not set up the e-business card. Please complete the setting first.",
              );
            } else {
              if (vm.lang == "tw") {
                alert("您尚未進行電子名片設定，請先完成設定。");
              } else {
                alert(
                  "You have not set up the e-business card. Please complete the setting first.",
                );
              }
            }
          }
        });
    },

    closefancybox() {
      parent.$.fancybox.close();
    },

    saveBoothDesign() {
      const vm = this;
      const url = "/apiExhibitors/EditOnlineExpoBoothType/";

      const info = {
        RegNo: vm.RegNo,
        Booth_Design: vm.Booth_Design,
        CSRF: vm.CSRF_Token,
      };

      axios.post(url, info).then(function (response) {
        if (response.data.Code == 200) {
          // alert('您已成功設定攤位版型！')
          vm.closefancybox();
          parent.window.location.reload();
        } else if (response.data.Code == 251 || response.data.Code == 500) {
          alert("系統忙碌，請稍後再試");
          vm.closefancybox();
          parent.window.location.reload();
        } else if (response.data.Code == 252) {
          alert(9);
          vm.closefancybox();
          document.location.href = `https://www.chanchao.com.tw/`;
        }
      });
    },

    EsaveBoothDesign() {
      const vm = this;
      const url = "/apiExhibitors/EditOnlineExpoBoothType/";

      const info = {
        RegNo: vm.RegNo,
        Booth_Design: vm.Booth_Design,
        CSRF: vm.CSRF_Token,
      };

      axios.post(url, info).then(function (response) {
        if (response.data.Code == 200) {
          // alert('您已成功設定攤位版型！')
          vm.closefancybox();
          parent.window.location.reload();
        } else if (response.data.Code == 251 || response.data.Code == 500) {
          alert("System is busy, please try again later.");
          vm.closefancybox();
          parent.window.location.reload();
        } else if (response.data.Code == 252) {
          vm.closefancybox();
          document.location.href = `https://www.chanchao.com.tw/`;
        }
      });
    },

    openCardModal() {
      $("#venderCard").modal("show");
    },
  },

  created() {
    const vm = this;

    //取得語系

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];

    //取得參展商總資訊
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`,
      )
      .then((response) => {
        vm.logoImg = response.data.Data.ExhLogo;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;
        vm.OnlineExhBegin = response.data.Data.OnlineExpoBegin;
        vm.OnlineExhEnd = response.data.Data.OnlineExpoEnd;
        vm.OnlineExhcode = response.data.Data.exhcode;

        let today = new Date();
        today.setDate(today.getDate());

        let OpenShowExhDate = new Date(response.data.Data.OnlineExpoBegin);
        // console.log(response.data.Data.OnlineExpoBegin)
        // console.log(OpenShowExhDate)

        OpenShowExhDate.setDate(OpenShowExhDate.getDate() - 14);

        // console.log(OpenShowExhDate)

        let CloseDay = new Date(response.data.Data.OnlineExpoEnd);
        CloseDay.setDate(CloseDay.getDate() + 1);

        // console.log(CloseDay)

        if (today > OpenShowExhDate && today < CloseDay) {
          vm.showOnlineExhLink = true;
        } else {
          vm.showOnlineExhLink = false;
        }
      });

    //取得Logo圖片 & 取得VIP等級
    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`)
      .then((response) => {
        // console.log(response.data.Data)

        //取得是否填寫狀態盤的值

        vm.OnlineExpolayoutStatus = response.data.Data.OnlineExpolayoutStatus;
        vm.PressReleaseStatus = response.data.Data.PressReleaseStatus;
        vm.VideoStatus = response.data.Data.VideoStatus;
        vm.ProductStatus = response.data.Data.ProductStatus;
        vm.BasicinformationStatus = response.data.Data.BasicinformationStatus;

        if (response.data.Data.Vip == 3) {
          vm.isVip = true;
        } else {
          vm.isVip = false;
        }

        vm.HasOnlineExpo = response.data.Data.Virtual;

        //取得是否開啟線上展權限
        axios
          .get(
            `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`,
          )
          .then((response) => {
            // console.log(response.data.Data)

            vm.openOnlineExpo = response.data.Data.OnlineExpo_Archived;

            if (vm.openOnlineExpo == 1 && vm.HasOnlineExpo == 1) {
              vm.showOnlineStatus = true;
            } else {
              vm.showOnlineStatus = false;
              window.location.href = `home?no=${vm.RegNo}`;
            }
          });

        //取得線上展總資料
        axios
          .get(
            `https://www.chanchao.com.tw/apiExhibitors/DisplayOnlineExpoControl/${vm.RegNo}`,
          )
          .then((response) => {
            // console.log(response.data.Data)

            vm.OnlineExpoProfile = response.data.Data;

            if (response.data.Data.Profile) {
              vm.r_Profile = response.data.Data.Profile.replace(/<br>/g, "\n");
            }

            if (vm.showOnlineExhLink) {
              vm.ExhibitorWebsite = response.data.Data.ExhibitorWebsite;
            }

            if (response.data.Data.Booth_Design) {
              vm.hasExpoTopic = true;

              vm.Booth_Design = response.data.Data.Booth_Design;
            } else {
              vm.hasExpoTopic = false;
              $(".isTopic").addClass("HideTopic");
            }

            vm.Serno = response.data.Data.Serno;
            if (
              response.data.Data.video_Link ||
              response.data.Data.videoLink_Youku
            ) {
              vm.ExpovideoLink = response.data.Data.video_Link;
              vm.videoLink_Youku = response.data.Data.videoLink_Youku;
              vm.hasExpoVideo = true;
            } else {
              vm.hasExpoVideo = false;
            }

            //須補足是VIP兩個版型的判斷式

            if (vm.isVip) {
              if (
                response.data.Data.Banner1M ||
                response.data.Data.Banner2M ||
                response.data.Data.Banner3M ||
                response.data.Data.Banner4M
              ) {
                vm.hasAllBanner = true;
              } else {
                vm.hasAllBanner = false;
              }
            } else {
              if (response.data.Data.Banner1M || response.data.Data.Banner2M) {
                vm.hasAllBanner = true;
              } else {
                vm.hasAllBanner = false;
              }
            }

            if (response.data.Data.Banner1L) {
              vm.ExpoM_Banner1 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/M/${response.data.Data.Banner1M}`;
              vm.ExpoL_Banner1 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner1L}`;
            } else {
              if (vm.lang == "tw") {
                vm.ExpoM_Banner1 = "./images/default_230x450.jpg";
                vm.ExpoL_Banner1 = "./images/default_230x450.jpg";
              } else {
                vm.ExpoM_Banner1 = "./../images/default_230x450.jpg";
                vm.ExpoL_Banner1 = "./../images/default_230x450.jpg";
              }
            }

            if (response.data.Data.Banner2L) {
              vm.ExpoM_Banner2 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/M/${response.data.Data.Banner2M}`;
              vm.ExpoL_Banner2 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner2L}`;
            } else {
              if (vm.lang == "tw") {
                vm.ExpoM_Banner2 = "./images/default_230x450.jpg";
                vm.ExpoL_Banner2 = "./images/default_230x450.jpg";
              } else {
                vm.ExpoM_Banner2 = "./../images/default_230x450.jpg";
                vm.ExpoL_Banner2 = "./../images/default_230x450.jpg";
              }
            }

            if (response.data.Data.Banner3L) {
              vm.ExpoM_Banner3 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/M/${response.data.Data.Banner3M}`;
              vm.ExpoL_Banner3 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner3L}`;
            } else {
              if (vm.lang == "tw") {
                vm.ExpoM_Banner3 = "./images/default_230x450.jpg";
                vm.ExpoL_Banner3 = "./images/default_230x450.jpg";
              } else {
                vm.ExpoM_Banner3 = "./../images/default_230x450.jpg";
                vm.ExpoL_Banner3 = "./../images/default_230x450.jpg";
              }
            }

            if (response.data.Data.Banner4L) {
              vm.ExpoM_Banner4 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/M/${response.data.Data.Banner4M}`;
              vm.ExpoL_Banner4 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner4L}`;
            } else {
              if (vm.lang == "tw") {
                vm.ExpoM_Banner4 = "./images/default_230x450.jpg";
                vm.ExpoL_Banner4 = "./images/default_230x450.jpg";
              } else {
                vm.ExpoM_Banner4 = "./../images/default_230x450.jpg";
                vm.ExpoL_Banner4 = "./../images/default_230x450.jpg";
              }
            }

            //判定是否為首次進入，及增加灰底效果

            if (
              !vm.hasExpoVideo &&
              !vm.hasExpoTopic &&
              !vm.hasAllBanner &&
              !vm.hasCard
            ) {
              vm.firstEntry = true;
              $(".AddGrayFrame").addClass("graystyle");
            } else {
              vm.firstEntry = false;
              $(".AddGrayFrame").removeClass("graystyle");
            }
          });
      });

    //取得線上展說明文字

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/BoothPreviewProduct/${vm.RegNo}`,
      )
      .then((response) => {
        // console.log(response.data.Data)
      });

    //判定存在卡片與否

    axios
      .get(
        `https://www.chanchao.com.tw/apiOnlineExpo/v2/Boothstaff/${vm.RegNo}`,
      )
      .then((response) => {
        // console.log(response.data.Data)

        vm.CardInfo = response.data;

        let findCard = vm.CardInfo.filter((item) => {
          return item.Verified == 1;
        });

        // console.log(findCard)

        if (findCard.length > 0) {
          vm.hasCard = true;
        } else {
          vm.hasCard = false;
        }
      });
  },
};
</script>

<style lang="scss">
.vendor_topic1 {
  background-image: url("../../../assets/images/Expo_Topic1.png");
}

.vendor_topic2 {
  background-image: url("../../../assets/images/Expo_Topic2.png");
}

.vendor_topicA3 {
  background-image: url("../../../assets/images/Expo_TopicA3.png");
}

.vendor_topicA4 {
  background-image: url("../../../assets/images/Expo_TopicA4.png");
}

.vendor_topicA5 {
  background-image: url("../../../assets/images/Expo_TopicA5.png");
}

.vendor_topicA6 {
  background-image: url("../../../assets/images/Expo_TopicA6.png");
}

.vendor_topic3 {
  background-image: url("../../../assets/images/Expo_Topic3.png");
}

.vendor_topic4 {
  background-image: url("../../../assets/images/Expo_Topic4.png");
}

.vendor_topic5 {
  background-image: url("../../../assets/images/Expo_Topic5.png");
}

.vendor_topic6 {
  background-image: url("../../../assets/images/Expo_Topic6.png");
}

.cc-selector input {
  margin: 0;
  padding: 0;
  appearance: none;
  display: none;
}

.cc-selector input:active + .drinkcard-cc {
  opacity: 0.9;
}

.cc-selector input:checked + .drinkcard-cc {
  -webkit-filter: none;
  -moz-filter: none;
  filter: none;
  filter: brightness(1) drop-shadow(2px 2px 2px #333);
  /* box-shadow: 5px 4px 14px -5px rgba(194, 180, 194, 0.68); */
}

.drinkcard-cc {
  cursor: pointer;
  background-size: contain;
  background-repeat: no-repeat;
  display: inline-block;
  width: 377px;
  height: 212px;
  transition: all 1s;
  filter: brightness(0.3) grayscale(1) opacity(0.7);
}

.drinkcard-cc:hover {
  filter: brightness(1) opacity(0.9);
}

@media screen and (max-width: 576px) {
  .drinkcard-cc {
    cursor: pointer;
    background-size: contain;
    background-repeat: no-repeat;
    display: inline-block;
    width: 257px;
    height: 150px;
    transition: all 1s;
    filter: brightness(0.3) grayscale(1) opacity(0.7);
  }
}
</style>
